import { trigger, state, style, transition, animate, AnimationTriggerMetadata } from '@angular/animations';

export const collapseAnimation: AnimationTriggerMetadata =
	trigger('smoothCollapse', [
		state( 'expanded', style({
			overflow: 'visible'
		})),
		state( 'collapsed', style({
			height: '0',
			overflow: 'hidden'
		})),
		transition( 'collapsed=>expanded', animate('400ms ease') ),
		transition( 'expanded=>collapsed', animate('200ms ease-out') )
	]);
